
  import { integrationsConfigService } from '@/services/integrations/integrationsConfigService';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { Icon } from '@/ui/components/icon/Icon';
  import { computed, defineComponent } from 'vue';

  export default defineComponent({
    components: {
      Icon,
    },
    setup() {
      const store = useIntegrationDetailsStore();
      const integration = store.integration!;
      const currentStep = computed(() => store.multiStep.currentStep);
      const isOpen = computed(() => store.isModalOpen);

      const steps = integrationsConfigService.prepareMultipleSteps(integration);
      const isCollapsed = (i: number, currentStep: number) => i < currentStep || i - currentStep > 1;

      return {
        currentStep,
        steps,
        isOpen,
        integration,
        onClose: store.closeModal,
        isCollapsed,
      };
    },
  });
